<template>
  <div>
    <router-link
      :to="{
        name: 'MapRoles',
        query: {
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id,
          category: data.name,
        },
      }"
      class="btn details_btn mr-2"
    >
      {{ $t("text.omit.mapRoles") }}
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>
